<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section-number" id="_idParaDest-6" title="SECTION I: God, the Brain and What Went Wrong"><a id="_idTextAnchor008"></a>SECTION I </h1>
<div class="chding">
<img alt="" class="img100" src="Images/brainding.jpg"/>
</div>
<h2 class="section-title sigil_not_in_toc" id="_idParaDest-7"><a id="_idTextAnchor009"></a>God, the Brain and <br/>What Went Wrong </h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pt1.vue?6ccf8b0a